const getCaseloadTypeFilter = response => {
  const formattedData = response.data.map(entry => ({
    id: entry.id,
    name: entry.name,
  }));

  return {
    key: 'caseloadType',
    source: 'caseloadType',
    filterName: 'Roster type',
    searchable: false,
    defaultSelection: formattedData,
    options: formattedData,
    selector: 'id',
    label: 'name',
  };
};

export default getCaseloadTypeFilter;
